module.exports = __webpack_public_path__ + "img/device-android-17fad26fd083b51c07600608c3a6f797.svg";